export function getStorageItem(key) {
    try {
        return localStorage.getItem(key)
    } catch (error) {
        if (!(error instanceof DOMException) || error.name !== 'SecurityError') {
            throw error
        }
    }

    try {
        return sessionStorage.getItem(key)
    } catch (error) {
        if (!(error instanceof DOMException) || error.name !== 'SecurityError') {
            throw error
        }
    }

    return undefined
}

export function setStorageItem(key, value) {
    try {
        localStorage.setItem(key, value)
    } catch (error) {
        if (!(error instanceof DOMException) || error.name !== 'SecurityError') {
            throw error
        }
    }

    try {
        sessionStorage.setItem(key, value)
    } catch (error) {
        if (!(error instanceof DOMException) || error.name !== 'SecurityError') {
            throw error
        }
    }
}
